/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S6_TitleInputs */

const en_guide_json_schema_s6_title = /** @type {(inputs: Guide_Json_Schema_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where JSON Schema pays off`)
};

const ko_guide_json_schema_s6_title = /** @type {(inputs: Guide_Json_Schema_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema가 빛을 발하는 곳`)
};

const ja_guide_json_schema_s6_title = /** @type {(inputs: Guide_Json_Schema_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema が効く場面`)
};

/**
* | output |
* | --- |
* | "Where JSON Schema pays off" |
*
* @param {Guide_Json_Schema_S6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s6_title = /** @type {((inputs?: Guide_Json_Schema_S6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s6_title(inputs)
	if (locale === "ko") return ko_guide_json_schema_s6_title(inputs)
	return ja_guide_json_schema_s6_title(inputs)
});